import React from 'react';
import './Marquee.css';

/**
 * Endless horizontal ticker. The list is rendered twice so the CSS translate
 * loop is seamless; the duplicate is hidden from assistive tech.
 */
export default function Marquee({ items, speed = 42, dark = false, className = '' }) {
  const run = (hidden) => (
    <ul className="marquee__track" aria-hidden={hidden || undefined}>
      {items.map((item, i) => (
        <li className="marquee__item" key={`${item}-${i}`}>
          <span className="display brand">{item}</span>
          <span className="marquee__dot" />
        </li>
      ))}
    </ul>
  );

  return (
    <div
      className={`marquee${dark ? ' marquee--dark' : ''}${className ? ` ${className}` : ''}`}
      style={{ '--marquee-duration': `${speed}s` }}
    >
      <div className="marquee__viewport">
        {run(false)}
        {run(true)}
      </div>
    </div>
  );
}
